<template>
  <transition name="fade">
    <div v-if="showOTPModal" class="otp-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>OTP Verification</h3>
          <button @click="closeModal" class="close-btn" aria-label="Close">×</button>
        </div>
        
        <div class="modal-body">
          <p>Please enter your phone number and OTP to continue</p>
          
          <div class="form-group">
            <label for="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              v-model="phoneNumber"
              placeholder="+1 234 567 8900"
              class="form-input"
            />
          </div>
          
          <div class="form-group">
            <label for="otp">OTP Code</label>
            <input
              type="text"
              id="otp"
              v-model="otp"
              placeholder="123456"
              maxlength="6"
              class="form-input"
            />
          </div>
          
          <button @click="verifyOTP" class="verify-btn" :disabled="verifying">
            {{ verifying ? 'Verifying...' : 'Verify OTP' }}
          </button>
          
          <div v-if="error" class="error-message">
            {{ error }}
          </div>
          
          <div class="otp-note">
            <p><small>For demo purposes, use OTP: <strong>123456</strong></small></p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'OTPModal',
  data() {
    return {
      phoneNumber: '',
      otp: '',
      verifying: false,
      error: ''
    }
  },
  computed: {
    ...mapState({
      showOTPModal: state => state.ecommerce.auth.showOTPModal
    })
  },
  watch: {
    showOTPModal(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('ecommerce/auth/SET_OTP_MODAL', false)
    },
    async verifyOTP() {
      if (!this.phoneNumber || !this.otp) {
        this.error = 'Please enter phone number and OTP'
        return
      }
      
      this.verifying = true
      this.error = ''
      
      try {
        const success = await this.$store.dispatch('ecommerce/auth/verifyOTP', this.otp)
        if (success) {
          this.$notify({
            title: 'Success',
            text: 'OTP verified successfully!',
            type: 'success'
          })
          this.closeModal()
        } else {
          this.error = 'Invalid OTP. Please try again.'
        }
      } catch (err) {
        this.error = 'Verification failed. Please try again.'
      } finally {
        this.verifying = false
      }
    },
    resetForm() {
      this.phoneNumber = ''
      this.otp = ''
      this.verifying = false
      this.error = ''
    }
  }
}
</script>

<style scoped>
.otp-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s ease;
}

.close-btn:hover {
  background: #f8f9fa;
}

.modal-body {
  padding: 20px;
}

.modal-body p {
  margin-bottom: 20px;
  color: #666;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  outline: none;
}

.form-input:focus {
  border-color: #2ed573;
}

.verify-btn {
  width: 100%;
  padding: 15px;
  background: #2ed573;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
}

.verify-btn:hover:not(:disabled) {
  background: #26c463;
}

.verify-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  margin-top: 15px;
  padding: 10px;
  background: #ffeaea;
  color: #ff4757;
  border-radius: 8px;
  font-size: 14px;
}

.otp-note {
  margin-top: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
  text-align: center;
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>